<template>
  <div class="form-group position-relative m-0">
    <label v-if="label" class="font-size-12">{{ label }}</label>
    <input ref="inputValue" v-model="iValue" type="text" class="form-control" :placeholder="placeholder" :style="inputStyle" />
  </div>
</template>

<script>
export default {
  props: {
    value: { type: [Number, String], default: '' },
    label: { type: [String], default: '' },
    placeholder: { type: [String], default: '' },
    textAlign: { type: String, default: 'center' },
    applyMinorPadding: { type: Boolean, default: true },
    min: { type: Number, default: 1 },
    max: { type: Number, default: 100 }
  },
  computed: {
    iValue: {
      get() { return this.value },
      set(newVal) {
        newVal = newVal.trim()
        newVal = this.calcPositiveInteger(newVal, this.min, this.max, this.$refs)
        this.$emit('input', newVal)
        this.$emit('change', this)
      }
    },
    inputStyle() {
      let style = {
        textAlign: this.textAlign
      }
      if (this.applyMinorPadding) {
        style = {
          ...style,
          padding: '0.3rem'
        }
      }
      return style
    }
  },
  methods: {
    calcPositiveInteger(newVal, min, max, $refs) {
      let shouldEmpty = false
      if (newVal === '' || isNaN(newVal)) {
        if (newVal === '') shouldEmpty = true
        else newVal = min
      } else if (parseFloat(newVal) < min) newVal = min
      else if (parseFloat(newVal) > max) newVal = max
      if (shouldEmpty) $refs.inputValue.value = ''
      else {
        newVal = parseInt(parseFloat(newVal))
        $refs.inputValue.value = newVal
      }
      return newVal
    }
  }
}
</script>